import { default as MuiTable } from '@mui/material/Table';
import { styled } from '../../theme';
import type { TableProps as MuiTableProps } from '@mui/material/Table';

export interface TableProps extends MuiTableProps {
    disableBorderBottom?: boolean;
}

export const Table = styled(MuiTable, {
    shouldForwardProp: (prop) => prop !== 'disableBorderBottom',
})<TableProps>(({ disableBorderBottom }) => ({
    ...(disableBorderBottom && {
        '& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': {
            borderBottom: 0,
        },
    }),
}));
